import './SellForm.css'
import { useState } from "react";
import validator from "validator";
import Input from "../../Input/Input";
import { Link } from "react-router-dom";
import { CheckedIcon } from "../../../assets/icons/icons";
import mainApi from "../../../assets/api/MainApi";
import { DropArrowIcon } from "../../../assets/icons/promoCatalog";
import { motion } from 'framer-motion';
import { CURRENCY, POSSIBLE_CONDITION, TYPES } from "../../../assets/utils/constants";
import MiniPreloader from "../../MiniPreloader/MiniPreloader";

const DEFAULT_FORM = {
  phone: "",
  first_name: "",
  last_name: "",
  material: '',
  reference_number: '',
  estimated_price: '',
  email: "",
  condition: "6",
  submit_type: "phone",
  checkbox: false,
  checkbox_material: false,
  checkbox_number: false,
  comment: ''
}

const DEFAULT_FORM_VALIDITY = {
  phone: {},
  email: {},
}

function SellForm() {
  const [info, setInfo] = useState(DEFAULT_FORM);
  const [infoValidity, setInfoValidity] = useState(DEFAULT_FORM_VALIDITY);

  const [selectedCondition, setSelectedCondition] = useState(null)
  const [isConditionOpen, setConditionOpen] = useState(false)
  function handleSelectCondition(item) {
      setSelectedCondition(item)
      setConditionOpen(false)
  }

  const [selectedCurrency, setSelectedCurrency] = useState(0)
  const [isCurrencyOpen, setCurrencyOpen] = useState(false)
  function handleSelectCurrency(item) {
      setSelectedCurrency(item)
      setCurrencyOpen(false)
  }

  function handleChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;

    switch (name) {
        case "phone":
            let inputValue = e.target.value.replace(/\D/g, '')
            let formattedInputValue = '';
            if (!inputValue) {
                setInfo(prevValue => ({
                    ...prevValue,
                    [name]: '',
                }))
                setInfoValidity((prevValue) => ({
                    ...prevValue,
                    [name]: {
                        errorMessage: '',
                        validState: false
                    }
                }))
            }
            else {
                if (['7', '8', '9'].indexOf(inputValue[0]) > -1) {
                    setInfoValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: '',
                            validState: false
                        }
                    }))
                    if (inputValue[0] === '9') inputValue = '7' + inputValue;

                    let firstSimbols = (inputValue[0] === '8') ? '8' : '+7';
                    formattedInputValue = firstSimbols + ' '

                    if (inputValue.length > 1) {
                        formattedInputValue += '(' + inputValue.substring(1, 4)
                    }
                    if (inputValue.length >= 5) {
                        formattedInputValue += ') ' + inputValue.substring(4, 7)
                    }
                    if (inputValue.length >= 8) {
                        formattedInputValue += '-' + inputValue.substring(7, 9)
                    }
                    if (inputValue.length >= 10) {
                        formattedInputValue += '-' + inputValue.substring(9, 11)
                    }
                    if (inputValue.length >= 11) {
                        setInfoValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: true
                            }
                        }));
                    } else {
                        setInfoValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: false
                            }
                        }));
                    }
                } else {
                    formattedInputValue = '+' + inputValue.substring(0, 16)
                    if (inputValue.length >= 11) {
                        setInfoValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: true
                            }
                        }));
                    } else {
                        setInfoValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: false
                            }
                        }));
                    }
                }


                setInfo(prevValue => ({
                    ...prevValue,
                    [name]: formattedInputValue,
                }))
            }

            break;

        case "email":
            if (!value) {
                setInfoValidity((prevValue) => ({
                    ...prevValue,
                    [name]: {
                        errorMessage: "",
                        validState: false,
                    },
                }));
            }
            if (value.length >= 2) {
                if (validator.isEmail(value)) {
                    setInfoValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: "",
                            validState: true,
                        },
                    }));
                } else {
                    setInfoValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: !e.target.validity.valid
                                ? e.target.validationMessage
                                : "Invalid email",
                            validState: false,
                        },
                    }));
                }
            }
            setInfo((prevValue) => ({
                ...prevValue,
                [name]: value,
            }));
            break;

        default:
            setInfo((prevValue) => ({
                ...prevValue,
                [name]: value,
            }));
            break;
    }
}

const [activeType, setActiveType] = useState(0)

function toggleCheckbox(type) {
    if (type === 'base') {
        setInfo(prevValue => ({
            ...prevValue,
            checkbox: !prevValue.checkbox,
        }))
    }
    if (type === 'material') {
        setInfo(prevValue => ({
            ...prevValue,
            checkbox_material: !prevValue.checkbox_material,
        }))
    }
    if (type === 'number') {
        setInfo(prevValue => ({
            ...prevValue,
            checkbox_number: !prevValue.checkbox_number,
        }))
    }
}
const [photos, setPhoto] = useState([]);

// Функция для обработки изменения файла
const uploadHandler = (e) => {
    const files = Array.from(e.target.files);
    // setIsPhotoLoading(true);

    function makeRequest(photo) {
        let data = new FormData();
        data.append("image", photo);

        return new Promise((resolve, reject) => {
            mainApi
                .sendSellToUs({ data })
                .then((res) => {
                    setPhoto((prevValue) => [...prevValue, res.urls.orig]);
                    resolve(res);
                    console.log(res, photos)
                })
                .catch((err) => {
                    console.log(err)
                });
        });
    }

    const DEFAULT_MAX_IMG_SIZE = 15;
    async function runAsync(files) {
        for (let file of files) {
            // console.log(file);
            if (file && file.size / 1000000 >= DEFAULT_MAX_IMG_SIZE) return;

            await makeRequest(file).catch((err) => {
                console.log(err);
            });
        }
    }

    runAsync(files).finally(() => {
        // console.log("FINISHED", photos);
        // const photosLength = product.photo.length + photos.length;
        // setIsPhotoLoading(false);
        // setProduct((prevValue) => ({
        //     ...prevValue,
        //     [name]: prevValue.photo ? prevValue.photo.concat(photos) : photos,
        // }));
        // setInfoValidity((prevValue) => ({
        //     ...prevValue,
        //     [name]: {
        //         errorMessage: photosLength <= 10 ? "" : null,
        //         //  ERROR_PHOTO_MAX_LENGTH,
        //         validState: photosLength <= 10,
        //     },
        // }));
    });
}

const isValid = (info.email && infoValidity.email.validState && info.comment && info.estimated_price && (info.checkbox_number || info.reference_number) && (info.checkbox_material || info.material) && photos && info.checkbox && selectedCondition !== null)
const [submitPreloader, setSubmitPreloader] = useState(false)
function sendRequest(e) {
    e.preventDefault()
    if (isValid) {
        setSubmitPreloader(true)
        mainApi.sendSellItem({
            email: info.email,
            category: TYPES[activeType].formated,
            description: info.comment,
            condition: POSSIBLE_CONDITION[selectedCondition],
            price: `${info.estimated_price} ${CURRENCY[selectedCurrency]}`,
            reference_number: info.checkbox_number ? 'not sure' : info.reference_number,
            material: info.checkbox_material ? 'not sure' : info.material,
            image_urls: photos
        })
            .then((res) => {
                console.log(res)
                setSelectedCondition(null)
                setSelectedCurrency(0)
                setInfo(DEFAULT_FORM)
                setPhoto([])
                setInfoValidity(DEFAULT_FORM_VALIDITY)
                setActiveType(0)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setSubmitPreloader(false)
            })
    }
}

    return (
        <form className="sell-form" id='sell-form' onSubmit={sendRequest}>
            <div >
                <div className="sell-form__types-menu">
                    {TYPES.map((item, i) => {
                        return (
                            <button type='button' onClick={() => setActiveType(i)} className={`sell-form__types ${activeType === i ? 'sell-form__types_active' : ''}`} key={i}>
                                {item.title}
                            </button>
                        )
                    })}
                </div>
                {/* personal-info__input_area */}
                <div className="sell-form__input-area ">
                    <Input
                        isTextArea
                        label={"Description"}
                        value={info.comment}
                        handleChange={handleChange}
                        name={"comment"}
                    // error={formValid.email}
                    ></Input>
                </div>

                <div className='promo-catalog__filters-brands-drop-container sell-form__drop'>
                    <button className='promo-catalog__filters-brands-selected' type='button' onClick={() => {
                        setConditionOpen(prevValue => !prevValue)
                    }}>
                        <p className='promo-catalog__filters-brands-selected-text'>{selectedCondition !== null ? POSSIBLE_CONDITION[selectedCondition] : 'Condition'}</p>
                        <DropArrowIcon
                            mainClassName={'promo-catalog__filters-brands-selected-arrow'}
                            fillClassName={'promo-catalog__filters-brands-selected-arrow-fill'}
                        />
                    </button>
                    {isConditionOpen ?
                        <motion.div
                            className='promo-catalog__filters-brands-dropdown'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                        >
                            {POSSIBLE_CONDITION && POSSIBLE_CONDITION.length > 0 ?
                                POSSIBLE_CONDITION.map((brand, i) => (
                                    <button className={`promo-catalog__filters-brands-dropdown-item ${selectedCondition === i ? 'promo-catalog__filters-brands-dropdown-item_selected' : ''}`} key={`promo-catalog__filters-brands-dropdown-item${i}`} type='button' onClick={() => {
                                        handleSelectCondition(i)
                                    }}>
                                        {brand}
                                    </button>
                                ))
                                : null}
                        </motion.div>
                        : null}
                </div>
                <div className="sell-form__currency">
                    <div className="personal-info__input">
                        <Input
                            label={"Estimated price"}
                            value={info.estimated_price}
                            handleChange={handleChange}
                            name={"estimated_price"}
                            inputMode='estimated_price'
                        // error={InfoValidity.email}
                        ></Input>
                    </div>
                    <div className='promo-catalog__filters-brands-drop-container sell-form__drop'>
                        <button className='promo-catalog__filters-brands-selected' type='button' onClick={() => {
                            setCurrencyOpen(prevValue => !prevValue)
                        }}>
                            <p className='promo-catalog__filters-brands-selected-text'>{selectedCurrency !== null ? CURRENCY[selectedCurrency] : 'USD'}</p>
                            <DropArrowIcon
                                mainClassName={'promo-catalog__filters-brands-selected-arrow'}
                                fillClassName={'promo-catalog__filters-brands-selected-arrow-fill'}
                            />
                        </button>
                        {isCurrencyOpen ?
                            <motion.div
                                className='promo-catalog__filters-brands-dropdown'
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                            >
                                {CURRENCY && CURRENCY.length > 0 ?
                                    CURRENCY.map((item, i) => (
                                        <button className={`promo-catalog__filters-brands-dropdown-item ${selectedCurrency === i ? 'promo-catalog__filters-brands-dropdown-item_selected' : ''}`} key={`promo-catalog__filters-brands-dropdown-item${i}`} type='button' onClick={() => {
                                            handleSelectCurrency(i)
                                        }}>
                                            {item}
                                        </button>
                                    ))
                                    : null}
                            </motion.div>
                            : null}
                    </div>
                </div>
                <div className="personal-info__input">
                    <Input
                        label={"Reference Number"}
                        value={info.reference_number}
                        handleChange={handleChange}
                        name={"reference_number"}
                    ></Input>
                    <div className={`sell-form__not-sure ${info.checkbox_number ? 'sell-form__not-sure_black' : ''}`}>
                        <button className={`personal-info__checkbox ${info.checkbox_number ? 'personal-info__checkbox_selected' : ''}`} onClick={() => toggleCheckbox('number')} type='button'>
                            <div className='personal-info__checkbox-box'>
                                <CheckedIcon mainClassName={'personal-info__checkbox-box-icon'} strokeClassName={'personal-info__checkbox-box-icon-stroke'} />
                            </div>
                        </button>
                        I’m not sure
                    </div>
                </div>
                <div className="personal-info__input">
                    <Input
                        label={"Material"}
                        value={info.material}
                        handleChange={handleChange}
                        name={"material"}
                    ></Input>
                    <div className={`sell-form__not-sure ${info.checkbox_material ? 'sell-form__not-sure_black' : ''}`}>
                        <button className={`personal-info__checkbox ${info.checkbox_material ? 'personal-info__checkbox_selected' : ''}`} onClick={() => toggleCheckbox('material')} type='button'>
                            <div className='personal-info__checkbox-box'>
                                <CheckedIcon mainClassName={'personal-info__checkbox-box-icon'} strokeClassName={'personal-info__checkbox-box-icon-stroke'} />
                            </div>
                        </button>
                        I’m not sure
                    </div>
                </div>

                <div className="personal-info__input">
                    <Input
                        label={"E-mail"}
                        value={info.email}
                        handleChange={handleChange}
                        name={"email"}
                        inputMode='email'
                    // error={formValid.email}
                    ></Input>
                </div>
                {/* <div className="personal-info__input">
                    <Input
                        label={"Phone Number"}
                        value={info.phone}
                        handleChange={handleChange}
                        name={"phone"}
                        inputMode='tel'
                        error={InfoValidity.phone}
                    ></Input>
                </div> */}
            </div>
            <div className="sell-form__photo-and-submit">
                <div className="sell-form__photo-block">
                    {photos.length > 0 ?
                        photos?.map((item, i) => (
                            <img key={i} src={item} alt="" className="sell-form__photo" ></img>
                        )) : null}
                    <div className="sell-form__add-photo">
                        <input multiple onChange={uploadHandler} type="file" className="sell-form__add-photo-input"></input>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect width="40" height="40" rx="20" fill="#F1F1F1" />
                            <path d="M20 14V26" stroke="black" stroke-width="2" stroke-linecap="round" />
                            <path d="M14 20L26 20" stroke="black" stroke-width="2" stroke-linecap="round" />
                        </svg>
                        Add Photo
                    </div>
                </div>
                <button className={`personal-info__checkbox ${info.checkbox ? 'personal-info__checkbox_selected' : ''}`} onClick={() => toggleCheckbox('base')} type='button'>
                    <div className='personal-info__checkbox-box'>
                        <CheckedIcon mainClassName={'personal-info__checkbox-box-icon'} strokeClassName={'personal-info__checkbox-box-icon-stroke'} />
                    </div>
                    <p className='personal-info__checkbox-text'>I confirm that I have read(a) and agree to the{' '}
                        <Link to={'/docs/privacy-policy'} className='personal-info__checkbox-text-link'>Privacy Policy.</Link>
                    </p>
                </button>
                <button type='submit' className={`sell-form__submit-btn ${!isValid ? 'sell-form__submit-btn_disabled' : ''}`}>
                    {submitPreloader ? <MiniPreloader /> : 'Request an Estimate'}
                </button>
            </div>
        </form>
    )
}

export default SellForm;